/** @file The IK values a panel shows: setup values, overlaid by keys sitting exactly on the playhead frame. */
import type { Doc, Id, IkConstraintDoc } from '@pose2d/format/types';
import type { EditTarget } from '../rigKit/rigView';
import { IK_KEYABLE, type IkKeyable } from './ikKeyable';

/** The keyable values shown, and which of them are keyed on the playhead frame. */
export interface IkShown {
  values: Pick<IkConstraintDoc, IkKeyable>;
  keyed: IkKeyable[];
}

/** Between keys the setup value is shown (no curve evaluation here; the viewport shows the pose), ruling E6-3. */
export function ikShown(doc: Doc, id: Id, ik: IkConstraintDoc, target: EditTarget): IkShown {
  const values = { mix: ik.mix, softness: ik.softness, bendPositive: ik.bendPositive, stretch: ik.stretch, compress: ik.compress };
  if (target.kind === 'setup') return { values, keyed: [] };
  const timelines = doc.animations[target.animation]?.ik[id];
  const keyed = IK_KEYABLE.filter((channel) => {
    const key = (timelines?.[channel] as { f: number; v: number | boolean }[] | undefined)?.find((k) => k.f === target.frame);
    if (key !== undefined) Object.assign(values, { [channel]: key.v });
    return key !== undefined;
  });
  return { values, keyed };
}
